export default class extends Controller {

  static targets = ['container', 'input'];

  connect() {
    this.inputTarget.addEventListener('focus', (e) => {
      this.containerTarget.classList.add('active');
    });

    this.inputTarget.addEventListener('blur', (e) => {
      this.containerTarget.classList.remove('active');
    });
  }

}



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/omnisearch-controller.js